
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DatePicker, { DateObject } from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import "react-multi-date-picker/styles/backgrounds/bg-dark.css";

export default function FieldStart({ startDatetime, onChange }) {
	const datePickerProps = {
		calendar: persian,
		locale: persian_fa,
		calendarPosition: "bottom-right",
		format: "YYYY/MM/DD HH:mm",
		plugins: [
			<TimePicker position="bottom" />
		],
		containerClassName: "w-full font-Vazir-400",
		inputClass:
			"w-full rounded-[12px] border border-darkBlue/15 bg-white px-4 pb-2 pt-6 font-Vazir-400 text-[14px] text-darkBlue outline-none transition focus:border-darkBlue/35 focus:ring-2 focus:ring-cta/15 text-right"
	};

	return (
		<>
			<div className="relative">
				<label className="absolute right-4 top-2 font-Vazir-400 text-[12px] text-darkBlue/55">
					تاریخ و زمان شروع
				</label>
				<DatePicker
					{...datePickerProps}
					value={startDatetime}
					onChange={onChange}
					minDate={new DateObject({ calendar: persian })}
				/>
			</div>
		</>
	)
}
